"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHARGE_FIELD_META = void 0;
var CHARGE_FIELD_META = [
    { key: "chargeName", label: "Charge Name", group: "Basic" },
    { key: "chargeType", label: "Charge Type", group: "Basic" },
    { key: "partyType", label: "Party Type", group: "Basic" },
    { key: "isActive", label: "Active", group: "Basic" },
    { key: "rateMode", label: "Rate Mode", group: "Rate" },
    { key: "rateValue", label: "Rate Value", group: "Rate" },
    { key: "scaleTiers", label: "Scale Tiers", group: "Rate" },
    { key: "unitMeasure", label: "Unit Measure", group: "Rate" },
    { key: "chargeFormula", label: "Charge Formula", group: "Rate" },
    { key: "effectiveStartDate", label: "Effective Start Date", group: "Dates" },
    { key: "effectiveEndDate", label: "Effective End Date", group: "Dates" },
    { key: "chartOfAccountCode", label: "Account Code (Tenant)", group: "Billing" },
    { key: "landlordChartOfAccountCode", label: "Account Code (Landlord)", group: "Billing" },
    { key: "tracking", label: "Tracking Categories", group: "Billing" },
    { key: "serviceId", label: "Service", group: "Linkage" },
    { key: "notes", label: "Notes", group: "Other" },
];
exports.CHARGE_FIELD_META = CHARGE_FIELD_META;
